export const studiesQueryKeys = {
  all: ['studies'],
  details: () => [...studiesQueryKeys.all, 'detail'],
  detail: (id) => [...studiesQueryKeys.details(), id],
};